import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import createStyles from "@material-ui/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Challenge from "../../../types/ChallengeQuestion";
import { capitalize } from "lodash";
import { dateService } from "../../../../common";
import _ from "lodash";
import { Chip } from "@material-ui/core";
const styles = (theme: Theme) =>
  createStyles({
    cardSec: {
      fontFamily: "Nunito",
      backgroundColor: "#fff",
      borderRadius: "4px",
      padding: "12px 14px",
      margin: "16px 0",
      border: "1px solid rgba(153, 153, 153, 0.4)",
    },
    profileImg: {
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      fontSize: "16px",
      fontWeight: 600,
      color: "#fff",
      textAlign: "center",
      padding: "4px",
      textTransform: "capitalize",
      marginRight: 5,
    },
    purpleColor: {
      background: "#CE9AF6",
    },
    greenColor: {
      background: "#379D0B",
    },
    mt5: {
      marginTop: "3px",
    },
    personName: {
      fontWeight: 600,
      fontSize: "1rem",
      color: "#333",
      maxWidth: "120px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "inline-block",
      marginRight: 5,
      textTransform: 'capitalize',
    },
    postTime: {
      fontSize: "0.875rem",
      color: "#666",
      verticalAlign: "7px",
    },
    postContent: {
      color: "#333",
      fontSize: 14,
      marginTop: 10,
      paddingLeft: 35,
      marginBottom: 0,
      paddingRight: 20,
      '&>div:nth-of-type(1)':{
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        '& p':{
          margin: 0,
        }
      }
    },

    attachments: {
      marginTop: "12px",
    },
    attachmentIcon: {
      marginRight: "6px",
    },
    attachmentNo: {
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "150%",
      color: "#333",
      marginRight: "12px",
      textTransform: "capitalize",
      cursor: "pointer",
    },
    popupLink: {
      fontSize: "14px",
      fontWeight: "bold",
      color: "#1d7dea",
      textTransform: "capitalize",
      cursor: "pointer",
      marginRight: 3,
    },
    actionSec: {
      // marginTop: "20px",
    },
    acceptAction: {
      fontSize: "14px",
      lineHeight: "150%",
      color: "#1d7dea",
      textTransform: "uppercase",
      marginRight: "16px",
      cursor: "pointer",
    },
    dismissAction: {
      fontSize: "14px",
      lineHeight: "150%",
      color: "#666",
      textTransform: "uppercase",
      cursor: "pointer",
    },
    openColor:{
      color:'#F4B40D !important',
      borderColor:'#F4B40D !important',
      height: 25
    },
    acceptColor:{
      color:'#1D7DEA !important',
      borderColor:'#1D7DEA !important'
    },
    dismissColor:{
      color:'#999999!important',
      borderColor:'#999999 !important'
    },
    displayFlex:{
      display: 'flex',
      alignItems: 'center',
    }
  });

interface Props {
  data: Challenge;
  viewIndex: number;
  classes: any;
  onViewFull: (index: number) => void;
  onDismiss: (challengeId: string) => void;
  onAccept: (challengeId: string) => void;
  isCreatedByLoggedInUser:boolean
}

function ChallengeItem(props: Props) {
  const { classes, onViewFull, onDismiss, onAccept, data, viewIndex ,isCreatedByLoggedInUser} = props;
  if (!data) {
    return null;
  }
  const {
    status,
    attachments,
    issueDescription,
    reviewer,
    _id,
    createdAt,
  } = data;
  const name = _.get(reviewer, "name", "");

  const getRandomColourClass = () => {
    const randomNo = Math.floor(Math.random() * 2);
    if (randomNo === 0) {
      return classes.greenColor;
    }
    return classes.purpleColor;
  };
 const getStatusColorCode=(status:string)=>{
    switch (status.toLowerCase()) {
      case "open":
        return classes.openColor
      case "accept":
        return classes.acceptColor
      case "dismiss":
          return classes.dismissColor
      default:
        return classes.primary
    }
 }
  return (
    <Grid container className={classes.cardSec}>
      {/* <Grid item xs={12} sm={2}> */}
      {/* <Grid
          className={[classes.profileImg, getRandomColourClass()].join(" ")}
        >
          <span>{capitalize(name[0])}</span>
        </Grid> */}
      {/* </Grid> */}
      <Grid item xs={12}>
        <Grid className={classes.profileContent}>
          <Grid>
            {/* <Grid
              className={[classes.profileImg, getRandomColourClass()].join(
                " "
              )}
            > */}
            {/* <span>{capitalize(name[0])}</span> */}
            {/* </Grid> */}
            <Grid container justify="space-between" alignItems="center">
              <Grid item className={classes.displayFlex}>
                <Grid
                  className={[
                    classes.profileImg,
                    getRandomColourClass(),
                  ].join(" ")}
                >
                  <span>{capitalize(name[0])}</span>
                </Grid>
                <span className={classes.personName}>
                  {capitalize(name)},
                </span>
                <span className={classes.postTime}>
                  {dateService.timeSince(createdAt)}
                </span>
              </Grid>

              <Grid item>
              <span className={classes.actionSec}>
              {isCreatedByLoggedInUser ? (
                status !== "open" ? (
                  <span>{capitalize(status)}</span>
                ) : (
                  <>
                    <span
                      className={classes.acceptAction}
                      onClick={() => onAccept(_id)}
                    >
                      Accept
                    </span>
                    <span
                      className={classes.dismissAction}
                      onClick={() => onDismiss(_id)}
                    >
                      Dismiss
                    </span>
                  </>
                )
              ) : (
                <span>
                  {
                    <Chip
                      label={_.capitalize(status)}
                      className={getStatusColorCode(status)}
                      classes={{ label: classes.chipLabel }}
                      variant="outlined"
                    />
                  }
                </span>
              )}
            </span>
              </Grid>
            </Grid>

            {/* <Grid> */}

            {/* <span className={classes.personName}>{capitalize(name)},</span>
            <span className={classes.postTime}>
              {dateService.timeSince(createdAt)}
            </span> */}

            {/* </Grid> */}


          </Grid>

          <Typography className={classes.postContent}>
            <div
              dangerouslySetInnerHTML={{ __html: issueDescription }}
            />
            <Typography className={classes.attachments}>
            <span
              onClick={() => onViewFull(viewIndex)}
              className={classes.popupLink}
            >
              View Full
            </span>&nbsp;
            {attachments && attachments.length > 0 && (
              <span className={classes.attachmentNo}>
                <span className={classes.attachmentIcon}>
                  <img
                    src="/assets/svg/myLibrary/attachment.svg"
                    alt="attachments"
                  />
                </span>{" "}
                {attachments.length} attachments
              </span>
            )}

          </Typography>
          </Typography>

        </Grid>
      </Grid>
    </Grid>
  );
}

// @ts-ignore
export default React.memo(withStyles(styles)(ChallengeItem));
